import { Header, Main } from '@pcrm/fe/ui-kit';
import { createFileRoute } from '@tanstack/react-router';
import { Network } from 'lucide-react';
import { UnderConstruction } from '../../components/under-construction';

/**
 * Zona „Tehnic", anunțată în meniu de la #110.
 *
 * ⚠️ **Singura zonă fără niciun ecran cerut încă** — nici măcar unul de construit. Intră
 * în meniu pentru că fondatorul vrea harta întreagă (#106 punctul 3), iar ruta asta e ce
 * o ține onestă: o intrare de meniu care n-ar duce nicăieri e exact defectul pe care îl
 * evita regula veche („se listează doar rutele care există").
 *
 * Când se cere primul ecran al zonei, fișierul devine layout, ca `/clienti` și `/setari`.
 */
export const Route = createFileRoute('/_authenticated/tehnic')({
  component: TehnicPagina,
});

function TehnicPagina() {
  return (
    <>
      <Header fixed>
        <h1 className="text-lg font-semibold">Tehnic</h1>
      </Header>

      <Main className="flex flex-1 flex-col gap-4 sm:gap-6">
        <UnderConstruction
          title="Tehnic"
          icon={Network}
          description="Zona tehnică a rețelei. Nu s-a cerut încă niciun ecran aici — locul e rezervat în meniu ca să se vadă unde vor sta lucrurile când vor fi cerute."
        />
      </Main>
    </>
  );
}
